<template>
  <div class="hero-banner" :class="theme" :style="heroBannerStyle">
    <div class="main-header-overlay">
      <div class="container">
        <div class="container-element">
          <h1>{{ heading }}</h1>
          <h2>{{ subheading }}</h2>
          <div class="buttons">
            <button v-if="hasButton('get-started')" class="btn-rounded fat" @click="$store.commit('openGetStartedDialog')">Get Started</button>
            <button v-if="hasButton('start-bidding')" class="btn-rounded fat" @click="$store.commit('openSignUpDialog')">Sign-up to start bidding</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'HeroBanner',
    props: {
      heading: {
        type: String,
        required: false,
        default: 'default heading'
      },
      subheading: {
        type: String,
        required: false,
        default: 'the default subheading'
      },
      image: {
        type: String,
        required: false,
        default: null
      },
      buttons: {
        type: Array,
        required: false,
        default: () => []
      },
      theme: {
        type: String, // valid values: dark, light, buyer
        required: false,
        default: 'dark'
      }
    },
    data() {
      return {
      }
    },
    computed: {
      heroBannerStyle() {
        return {
          backgroundImage: 'url(' + this.image + ')'
        }
      }
    },
    methods: {
      hasButton(button) {
        return this.buttons.indexOf(button) > -1
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../pfx.scss';

  $hero-banner-min-height: 30rem;
  $hero-banner-height: 60vh;

  .hero-banner {
    background-size: cover;
    background-position: center;
    height: $hero-banner-height;
    min-height: $hero-banner-min-height;
    width: 100%;
    &.dark {
      color: white;
      background-color: #918f99;

      .main-header-overlay {
        background-color: rgba(#000, 0.5);
      }
    }
    &.buyer {
      color: white;
      background-color: dimgrey;

      .main-header-overlay {
        background-color: rgba(21, 37, 42, 0.29);
      }
    }
    &.sellers {
      color: white;
      background-color: dimgrey;

      .main-header-overlay {
        background-color: rgba(21, 37, 42, 0.4);
      }
    }
    &.light {
      color: black;
      background-color: lightgrey;

      .main-header-overlay {
        background-color: rgba(#fff, 0.6);
      }
    }
    &.faq {
      color: white;
      background-color: #918f99;

      .main-header-overlay {
        background-color: rgba(#000, 0.5);
      }
    }

    .container {
      height: $hero-banner-height;
      min-height: $hero-banner-min-height;
      padding: 1rem;
      position: relative;

      .container-element {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 80vw;
        text-align: center;
        max-width: 700px;
      }

      h1 {
        font-family: 'Encode Sans', sans-serif;
        font-size: 24px;
        font-weight: 600;
        line-height: 1.25;
        letter-spacing: 0;
        margin: 0 auto;
        @include tablet-portrait-breakpoint {
          font-size: 32px;
        }
      }

      h2 {
        font-family: 'Encode Sans', sans-serif;
        font-size: 20px;
        font-weight: 400;
        line-height: 1.25;
        margin: 2rem auto 0;
        @include tablet-portrait-breakpoint {
          font-size: 24px;
        }
      }

      .buttons {
        margin-top: 2rem;
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/elements/HeroBanner.vue